import * as cart from '@shopify/theme-cart';
import * as currency from '@shopify/theme-currency';
import Toastify from 'toastify-js';
const deleteItemKey = (key) => {
    cart
        .removeItem(key)
        .then((cart) => {
        document.querySelector('cart-component').removeItem(key);
    })
        .catch((error) => {
        console.error(error);
        Toastify({
            text: 'Ya no es posible eliminar el producto',
            duration: 3000,
            gravity: 'bottom',
            position: 'left',
            close: true,
        }).showToast();
    })
        .finally(() => {
        document.querySelectorAll('cart-icon').forEach((icon) => {
            icon.calculateItems();
        });
    });
};
class CartComponent extends HTMLElement {
    constructor() {
        super();
        this.itemsElement = this.querySelector('#items');
        this.closeBtn = this.querySelector('button[close]');
        this.total = this.querySelector('#total');
        this.butnowBtn = this.querySelector('#buynow');
        this.titleElement = this.querySelector('h2');
        this.lineItemsElement = [];
        this.sideCartElement = this.querySelector('.cart');
    }
    connectedCallback() {
        this.total.innerText = currency.formatMoney(0);
        this.addEventListener('mousedown', (e) => e.target === this && this.close());
        this.closeBtn && this.closeBtn.addEventListener('click', () => this.close());
        this.renderSectionFromFetch();
    }
    open() {
        this.classList.add('-active');
        document.documentElement.style.overflow = 'hidden';
        this.lineItemsElement = [...document.querySelectorAll('.product-item')].reverse();
    }
    close() {
        this.classList.remove('-active');
        document.documentElement.style.overflow = 'auto';
    }
    updateTotal() {
        cart.getState().then((state) => {
            this.total.innerText = currency.formatMoney(state.total_price);
            if (state.item_count > 0) {
                this.butnowBtn.classList.remove('-disabled');
                this.butnowBtn.setAttribute('href', '/checkout');
            }
            else {
                this.butnowBtn.classList.add('-disabled');
                this.butnowBtn.setAttribute('href', '#');
            }
        });
    }
    renderSectionFromFetch() {
        const url = `/cart?sections[]=products-items`;
        fetch(url)
            .then((response) => response.json())
            .then((html) => {
            html = html['products-items'];
            this.itemsElement.innerHTML = new DOMParser()
                .parseFromString(html, 'text/html')
                .querySelector('.shopify-section').innerHTML;
            this.lineItemsElement = [...this.itemsElement.children];
            this.updateTotal();
        });
    }
    addItem() {
        this.renderSectionFromFetch();
        this.open();
    }
    updateItem(key, quantity) {
        const item = this.itemsElement.querySelector(`.product-item[data-key="${key}"]`);
        item.querySelector('[quantity]').value = quantity;
        this.updateTotal();
    }
    removeItem(key) {
        this.itemsElement.querySelector(`.product-item[data-key="${key}"]`).remove();
        this.updateTotal();
    }
}
customElements.define('cart-component', CartComponent);
class CartIcon extends HTMLElement {
    constructor() {
        super();
        this.cart = document.querySelector('cart-component');
        this.button = this.querySelector('button');
        this.itemsQuantity = 0;
    }
    connectedCallback() {
        this.calculateItems();
        this.button.addEventListener('click', () => {
            this.cart.open();
        });
    }
    setItemsQuantity(quantity) {
        this.itemsQuantity = quantity;
        this.button.querySelector('.data-quantity').innerHTML = quantity;
    }
    calculateItems() {
        cart.getState().then((cart) => {
            this.setItemsQuantity(cart.item_count);
        });
    }
}
customElements.define('cart-icon', CartIcon);
class AddProductButton extends HTMLElement {
    constructor() {
        super();
        this.cart = document.querySelector('cart-component');
        this.icons = document.querySelectorAll('cart-icon');
        this.button = this.querySelector('button');
    }
    connectedCallback() {
        this.button.addEventListener('click', this.addItem.bind(this));
    }
    addItem() {
        cart
            .addItem(Number(this.button.dataset.id))
            .then(this.onSuccess.bind(this))
            .catch(this.onError.bind(this))
            .finally(() => {
            this.icons.forEach((icon) => {
                icon.calculateItems();
            });
        });
    }
    onSuccess(cart) {
        this.cart.addItem();
    }
    onError(error) {
        console.error(error);
        Toastify({
            text: 'Ya no es posible agregar mas productos',
            duration: 3000,
            gravity: 'bottom',
            position: 'left',
            close: true,
            duration: 3000
        }).showToast();
    }
}
customElements.define('add-product-button', AddProductButton);
class BuyNowButton extends AddProductButton {
    constructor() {
        super();
    }
    onSuccess(cart) {
        super.onCorrectAdd(cart);
        location.href = '/checkout';
    }
    onError(error) {
        super.onError(error);
        location.href = '/checkout';
    }
}
customElements.define('buy-now-button', BuyNowButton);
class UpdateProduct extends HTMLElement {
    constructor() {
        super();
        this.productType = Boolean(this.getAttribute('product') === 'true' || false);
        this.quantity = this.querySelector('.quantity-btn');
        this.key = this.getAttribute('key');
        this.max = this.getAttribute('max') | 100;
        this.oldQuantity = 1;
        /**
         * @type {QuantityModal}
         */
        this.modal = document.querySelector('quantity-modal');
    }
    static get observedAttributes() {
        return ['key', 'max', 'oldQuantity'];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue !== newValue) {
            this[name] = newValue;
        }
    }
    connectedCallback() {
        this.quantity.addEventListener('click', this.openModal.bind(this));
        this.oldQuantity = this.count;
    }
    disconnectedCallback() {
        this.quantity.removeEventListener('change', this.openModal.bind(this));
    }
    get count() {
        const innerQuantity = this.quantity.innerHTML;
        return Number(innerQuantity);
    }
    openModal() {
        setTimeout(() => {
            this.modal?.setProductType(this.productType);
        }, 0);
        this.modal.open(this.key, this.count);
    }
    disabledElements(disabled = true) {
        this.upBtn.disabled = disabled;
    }
    showErrorMessage(quantity = this.oldQuantity) {
        const message = `No se puede agregar mas de ${quantity} productos`;
        Toastify({
            text: message,
            duration: 3000,
            gravity: 'bottom',
            position: 'center',
            close: true,
        }).showToast();
    }
}
customElements.define('update-quantity', UpdateProduct);
class QuantityModal extends HTMLElement {
    constructor() {
        super();
        this.options = [1, 2, 3, 4, 5];
        this.key = '';
        this.quantity = 1;
        this.takeInput = false;
        this.productType = false;
    }
    setProductType(type) {
        this.productType = type;
    }
    connectedCallback() {
        this.insertHTML();
        this.listenButtons();
        this.listenInput();
        this.listenAcceptButton();
    }
    open(key, quantity) {
        this.key = key;
        this.quantity = quantity;
        this.modal.querySelector('input').value = '';
        this.modal.open();
        this.selectActual(quantity);
    }
    selectActual(quantity) {
        this.modal.querySelectorAll('.option').forEach((option) => {
            option.classList.remove('-selected');
        });
        this.modal.querySelector(`.option[data-quantity="${quantity}"]`).classList.add('-selected');
        this.quantity = quantity;
    }
    listenButtons() {
        this.modal.querySelectorAll('.option').forEach((option) => {
            option.addEventListener('click', () => {
                this.selectActual(option.dataset.quantity);
                this.takeInput = false;
                this.modal.close();
                this.updateQuantity();
            });
        });
    }
    listenInput() {
        this.modal.querySelector('input').addEventListener('input', (event) => {
            this.quantity = event.target.value;
            this.takeInput = true;
        });
    }
    listenAcceptButton() {
        this.modal.querySelector('button.-primary').addEventListener('click', () => {
            this.modal.close();
            this.updateQuantity();
        });
    }
    updateQuantity() {
        if (!this.productType) {
            cart.updateItem(this.key, { quantity: Number(this.quantity) })
                .then(this.onSuccess.bind(this))
                .catch(this.onError.bind(this))
                .finally(() => {
                document.querySelectorAll('cart-icon').forEach((icon) => {
                    icon.calculateItems();
                });
            });
        }
        else {
            document.querySelector('input#quantityValue').value = this.quantity;
            document.querySelector('product-form button.quantity-btn').innerHTML = this.quantity;
            const curerentButnow = document.querySelector('#checkoutLink');
            const curerentButnowLink = curerentButnow.href;
            // Replace "/cart/{{ current.id }}:1" with "/cart/{{ current.id }}:{{ quantity }}"
            curerentButnow.href = curerentButnowLink.replace(/\/cart\/(\d+):(\d+)/, `/cart/$1:${this.quantity}`);
        }
    }
    onSuccess(cart) {
        document.querySelector('cart-component').addItem();
    }
    onError(error) {
        console.error(error);
        Toastify({
            text: 'Ya no es posible agregar mas productos',
            duration: 3000,
            gravity: 'bottom',
            position: 'left',
            offset: { y: 120 },
            close: true,
        }).showToast();
    }
    insertHTML() {
        document.querySelector('body').insertAdjacentHTML('beforeend', `
      <component-modal id="quantityModal">
        <div class="quantity-modal-wrapper">
          <label for="quantity">Cantidad</label>
          <nav class="options">
            ${this.options.map((option, i) => {
            return `<button class="option" data-quantity="${option}">${option} unidad${i === 0 ? '' : 'es'}</button>`;
        }).join('')}
          </nav>
          <input type="number" name="quantity" id="quantity" value="${this.quantity}" min="1" max="100" placeholder="Ingrese la cantidad">
          <button class="c-button -primary"
            aria-label="Aceptar"
          >
            Aceptar
          </button>
        </div>
      </component-modal>
      `);
        this.modal = document.querySelector('component-modal#quantityModal');
    }
}
customElements.define('quantity-modal', QuantityModal);
class RemoveProductButton extends HTMLElement {
    constructor() {
        super();
        const key = this.dataset.key;
        this.button = this.querySelector('button');
        this.button.addEventListener('click', deleteItemKey.bind(this, key));
    }
}
customElements.define('remove-product-button', RemoveProductButton);
